import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { API, L } from './shared';

export const InvitePreviewDialog = ({ open, onClose, buildingId, apartmentId, formLang, count, onConfirm, lang, adminEmail }) => {
  const [pv, setPv] = useState(null);
  const [testTo, setTestTo] = useState(adminEmail || '');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setPv(null);
    axios.post(`${API}/buildings/${buildingId}/owner-feedback/invite-preview`, { lang: formLang, apartment_id: apartmentId })
      .then((r) => setPv(r.data)).catch((e) => toast.error(e.response?.data?.detail || 'Error'));
  }, [open, buildingId, apartmentId, formLang]);

  const sendTest = async () => {
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/buildings/${buildingId}/owner-feedback/invite-test`, { lang: formLang, apartment_id: apartmentId, to: testTo })).data;
      if (r.email_status.startsWith('failed')) toast.error(r.email_status);
      else toast.success(L(lang, `Δοκιμαστική πρόσκληση στάλθηκε στο ${r.to}`, `Test invitation sent to ${r.to}`));
    } catch (e) { toast.error(e.response?.data?.detail || 'Error'); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="of-invite-preview-dialog">
        <DialogHeader><DialogTitle>{L(lang, 'Προεπισκόπηση πρόσκλησης', 'Invitation preview')}</DialogTitle></DialogHeader>
        {!pv ? <p className="text-sm text-zinc-400 py-6 text-center">…</p> : (
          <>
            <div className="text-xs text-zinc-500">{L(lang, 'Θέμα', 'Subject')}: <b className="text-zinc-800" data-testid="of-preview-subject">{pv.subject}</b></div>
            <div className="border border-zinc-200 p-4 mt-2 bg-zinc-50" data-testid="of-preview-body" dangerouslySetInnerHTML={{ __html: pv.html }} />
            <p className="text-[11px] text-zinc-500 mt-1">{L(lang, 'Στην πραγματική αποστολή κάθε ιδιοκτήτης λαμβάνει δικό του ασφαλή σύνδεσμο.', 'In the real send, every owner receives their own secure link.')}</p>
          </>
        )}
        <div className="border-t border-zinc-200 pt-3 mt-2">
          <div className="text-xs font-semibold mb-1">{L(lang, 'Δοκιμή ολόκληρης της διαδικασίας (στέλνεται ΜΟΝΟ σε εσάς)', 'Test the full workflow (sent ONLY to you)')}</div>
          <div className="flex gap-2">
            <Input className="h-8 rounded-none" value={testTo} onChange={(e) => setTestTo(e.target.value)} data-testid="of-test-email-input" />
            <Button variant="outline" className="h-8 rounded-none" disabled={busy || !testTo} onClick={sendTest} data-testid="of-send-test-btn">{L(lang, 'Αποστολή δοκιμής', 'Send test')}</Button>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-none" onClick={onClose} data-testid="of-preview-cancel">{L(lang, 'Άκυρο', 'Cancel')}</Button>
          {count > 0 && <Button className="rounded-none bg-zinc-900" onClick={onConfirm} data-testid="of-confirm-send-btn">{L(lang, `Επιβεβαίωση αποστολής σε ${count} ${count === 1 ? 'ιδιοκτήτη' : 'ιδιοκτήτες'}`, `Confirm sending to ${count} ${count === 1 ? 'owner' : 'owners'}`)}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InvitePreviewDialog;
